/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + "月" + d.getDate() + "日" + d.getHours() + "时" + d.getMinutes() + "分";
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;
    else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xdc00 && code <= 0xdfff) i--;
  }
  return s;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return "";
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return "";
      return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
    })
  ).join("&");
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split("?")[1]).replace(/\+/g, " ");
  if (!search) {
    return {};
  }
  const obj = {};
  const searchArr = search.split("&");
  searchArr.forEach(v => {
    const index = v.indexOf("=");
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement("div");
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== "object") {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property];
    if (typeof sourceProperty === "object") {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += "" + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === "start") {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "deepClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + "";
  const randomNum = parseInt((1 + Math.random()) * 65536) + "";
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += " " + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
  }
}

/** **千进制转换，保留两位小数*/
export function numFormat(num) {
  if (num === 0) {
    return "0.00";
  }
  let newnum = parseFloat(num).toFixed(2);
  if (newnum === "NaN") {
    return "-";
  }
  newnum = newnum.toString().split("."); // 分隔小数点
  const arr = newnum[0].split("").reverse(); // 转换成字符数组并且倒序排列
  let res = [];
  for (let i = 0, len = arr.length; i < len; i++) {
    if (i % 3 === 0 && i !== 0) {
      if (arr[i] !== "-") {
        res.push(","); // 添加分隔符
      }
    }
    res.push(arr[i]);
  }
  res.reverse(); // 再次倒序成为正确的顺序
  if (newnum[1]) {
    // 如果有小数的话添加小数部分
    res = res.join("").concat("." + newnum[1]);
  } else {
    res = res.join("");
  }
  return res;
}

/** **千进制转换*/
export function numFormat1(num) {
  num = num.toString().split("."); // 分隔小数点
  var arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
  var res = [];
  for (var i = 0, len = arr.length; i < len; i++) {
    if (i % 3 === 0 && i !== 0) {
      if (arr[i] !== "-") {
        res.push(","); // 添加分隔符
      }
    }
    res.push(arr[i]);
  }
  res.reverse(); // 再次倒序成为正确的顺序
  if (num[1]) {
    // 如果有小数的话添加小数部分
    res = res.join("").concat("." + num[1]);
  } else {
    res = res.join("");
  }
  return res;
}

/**
 * 格式化数字
 * @param num 要格式化的数字
 * @param len 保留小数位数默认2
 * @return string
 */
export function formatNumber(num, len) {
  len = len > 0 && len <= 20 ? len : 2;
  var result = parseFloat(num);
  num = isNaN(result) ? 0 : result;
  var numpow = Math.pow(10, len);
  result = Math.floor(num * numpow) / numpow;
  // round四舍五入 ceil进一 floor舍去
  var s_x = result.toString();
  var pos_decimal = s_x.indexOf(".");
  if (pos_decimal < 0) {
    pos_decimal = s_x.length;
    s_x += ".";
  }
  while (s_x.length <= pos_decimal + len) {
    s_x += "0";
  }
  return s_x;
}

/**
 * 金额小写转大写
 * @param n 要转换的金额
 * @return string
 */
export function smalltoBIG(n) {
  var fraction = ["角", "分"];
  var digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
  var unit = [
    ["元", "万", "亿"],
    ["", "拾", "佰", "仟"]
  ];
  var head = n < 0 ? "欠" : "";
  n = Math.abs(n);
  var s = "";
  for (var k = 0; k < fraction.length; k++) {
    s += (digit[Math.floor(n * 10 * Math.pow(10, k)) % 10] + fraction[k]).replace(/零./, "");
  }
  s = s || "整";
  n = Math.floor(n);
  for (var i = 0; i < unit[0].length && n > 0; i++) {
    var p = "";
    for (var j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p;
      n = Math.floor(n / 10);
    }
    s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
  }
  return (
    head +
    s
      .replace(/(零.)*零元/, "元")
      .replace(/(零.)+/g, "零")
      .replace(/^整$/, "零元整")
  );
}

/**
 * 获取当前日期的后6个月的日期
 * @param date
 * @returns {[]}
 */
export function getNextMonth(date) {
  var arr = date.split("-");
  var year = arr[0]; // 获取当前日期的年份
  var month = arr[1]; // 获取当前日期的月份
  var day = arr[2]; // 获取当前日期的日
  var year2 = year;
  var month2 = parseInt(month) + 6;
  if (month2 > 12) {
    year2 = parseInt(year2) + 1;
    month2 = month2 - 12;
  }
  var day2 = day;
  var days2 = new Date(year2, month2, 0);
  days2 = days2.getDate();
  if (day2 > days2) {
    day2 = days2;
  }
  if (month2 < 10) {
    month2 = "0" + month2;
  }
  var t2 = year2 + "-" + month2 + "-" + day2;
  return t2;
}

/**
 * 计算两个日期相差天数
 * @param sDate1
 * @param sDate2
 * @returns {string | null}
 */
export function DateDiff(sDate1, sDate2) {
  var aDate, oDate1, oDate2, iDays;
  aDate = sDate1.split("-");
  oDate1 = new Date(aDate[1] + "-" + aDate[2] + "-" + aDate[0]);
  aDate = sDate2.split("-");
  oDate2 = new Date(aDate[1] + "-" + aDate[2] + "-" + aDate[0]);
  iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24);
  return iDays;
}

/**
 * 两个日期相差天数
 * @param dateRange 日期范围数组，格式为 ["2023-01-01", "2023-01-31"]
 * @param days 可选参数，默认值为31天
 * @returns {boolean} 如果日期范围超过指定天数，返回true；否则返回false
 */

export function calculateDateDiff(startDate, endDate) {
  if (!startDate || !endDate || !/^\d{4}-\d{2}-\d{2}$/.test(startDate) || !/^\d{4}-\d{2}-\d{2}$/.test(endDate)) {
    return -1;
  }
  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);
  const end = new Date(endDate);
  end.setHours(0, 0, 0, 0);
  const msDiff = end - start;
  const dayDiff = Math.ceil(msDiff / (1000 * 60 * 60 * 24));
  return dayDiff;
}
/**
 * 校验日期范围是否超过指定天数
 * @param dateRange 日期范围数组，格式为 ["2023-01-01", "2023-01-31"]
 * @param days 可选参数，默认值为31天
 * @returns {boolean} 如果日期范围超过指定天数，返回true；否则返回false
 */
export function checkDateOverDays(dateRange, days = 31) {
  if (!Array.isArray(dateRange) || dateRange.length !== 2) {
    return false;
  }
  const [start, end] = dateRange;
  const dayDiff = calculateDateDiff(start, end);
  return dayDiff > days || dayDiff < 0;
}

/**
 * 乘法丢失精度问题
 */
export function floatMultiply(arg1, arg2) {
  var n1, n2;
  var r1, r2;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  n1 = Number(arg1.toString().replace(".", ""));
  n2 = Number(arg2.toString().replace(".", ""));
  return (n1 * n2) / Math.pow(10, r1 + r2);
}

// 希尔排序
export function xier(arr) {
  var interval = parseInt(arr.length / 2); // 分组间隔设置
  while (interval > 0) {
    for (var i = 0; i < arr.length; i++) {
      var n = i;
      while (arr[n] < arr[n - interval] && n > 0) {
        var temp = arr[n];
        arr[n] = arr[n - interval];
        arr[n - interval] = temp;
        n = n - interval;
      }
    }
    interval = parseInt(interval / 2);
  }
  return arr;
}

export async function copyContent(content) {
  let copyResult = true;
  const text = content || "复制内容为空哦~";
  if (window.navigator.clipboard) {
    await window.navigator.clipboard.writeText(text).catch(() => {
      copyResult = copyContent2(text);
    });
  } else {
    copyResult = copyContent2(text);
  }
  if (copyResult) {
    this.$message.success("复制成功");
  } else {
    this.$message.error("复制失败");
  }
}

function copyContent2(text) {
  let copyResult = true;
  const inputDom = document.createElement("textarea");
  inputDom.setAttribute("readonly", "readonly");
  inputDom.value = text;
  document.body.appendChild(inputDom);
  inputDom.select();
  const result = document.execCommand("copy");
  if (!result) {
    copyResult = false;
  }
  document.body.removeChild(inputDom);
  return copyResult;
}

export function hiddenStr(str) {
  if (str.length <= 4) {
    return "*".repeat(str.length);
  }
  const maskedPart = "*".repeat(str.length - 4);
  return str.slice(0, 2) + maskedPart + str.slice(-2);
}
// 数字展示动画
export function animateTo(target) {
  this.isAnimating = true;
  let start = 0;
  const duration = 3000; // 动画时长3秒
  const increment = target / (duration / 16); // 每帧增量
  const update = () => {
    start += increment;
    this.displayValue = Math.min(Math.floor(start), target);
    if (start < target) requestAnimationFrame(update);
  };
  update();
}

/**
 *
 * @param {*} text 文本
 * @returns
 */
export function formatText(text) {
  return text ? text.replace(/\n/g, "<br>") : "";
}

// 筛选select
export const getOptionLabel = (options, value = "0", key = "value", defaultName = "-") => {
  // 查找匹配的选项
  if (value === undefined || value === null || value === "") return defaultName;
  const foundOption = options.find(option => option[key]?.toString() === value.toString());
  // 存在则返回name，否则返回默认值
  return foundOption ? foundOption.name || foundOption.label : defaultName;
};

// 返回原始状态
export const retStatus = item => {
  setTimeout(() => {
    item.name = item.nameTest;
    item.type = item.primary;
    item.disabled = false;
  }, 5000);
};

/**
 * 把参 {
 *  name: "name",
 *  age: "age",
 * } 转成 name=xx&age=xx
 */
export function buildQuery(params) {
  if (!params) return "";
  return Object.keys(params)
    .filter(key => params[key])
    .map(key => `${key}=${params[key] ?? ""}`)
    .join("&");
}
export function formatDateTimeInfo(timeStr) {
  if (!timeStr) return "-";
  const date = new Date(timeStr);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")} 
${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
}
// 兼容方案：通过 textarea + execCommand 实现复制
export function fallbackCopy(text) {
  const textarea = document.createElement("textarea");
  textarea.readOnly = true;
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  const ok = document.execCommand("copy");
  document.body.removeChild(textarea);
  if (ok) {
    this.$message.success("复制成功");
  } else {
    this.$message.error("复制失败，请手动复制");
  }
}
